import { getProductImage } from '@zola-helpers/client/dist/es/util/productHelper';
import type { WProductLookView, WProductView, WSkuPreview } from '@zola/svc-web-api-ts-client';
import { RegistryItemAdded } from '@zola/tracking-contracts/src/events';
import { trackRegistryItemAdded } from '@zola/tracking-contracts/src/tracking';

const getProductData = (products: WProductView[], skuId: string) => {
  let productIndex = -1;
  let product: WProductView | undefined;
  let productLook: WProductLookView | undefined;
  let skuPreview: WSkuPreview | undefined;
  products.some((currentProduct, index) => {
    return currentProduct.product_look_views?.some((currentProductLook) => {
      return currentProductLook.sku_previews?.some((currentSkuPreview) => {
        if (currentSkuPreview.id === skuId) {
          productIndex = index;
          product = currentProduct;
          productLook = currentProductLook;
          skuPreview = currentSkuPreview;
          return true;
        }
        return false;
      });
    });
  });
  return { productIndex, product, productLook, skuPreview };
};

export const trackInstantRegistryItemsAdded = (
  section: RegistryItemAdded['section'],
  products: WProductView[],
  selectedSkuIds: string[],
  registryId?: string
) => {
  selectedSkuIds.forEach((skuId) => {
    const { productIndex, product, productLook, skuPreview } = getProductData(products, skuId);
    if (product && productLook && skuPreview) {
      const eventConfig: RegistryItemAdded = {
        sku: skuId,
        category: 'UNATTRIBUTED',
        name: product.name || '',
        brand: product.brand?.name || '',
        price: (skuPreview.price_cents || 0) / 100,
        quantity: 1,
        image_url: getProductImage(productLook, 'medium', true) || '',
        product_uuid: product.id || '',
        registry_id: registryId || '',
        position: productIndex + 1,
        location: 'INSTANT_REGISTRY',
        section,
      };
      trackRegistryItemAdded(eventConfig);
    }
  });
};
